import React, {Component} from "react";
import PropTypes from "prop-types";
import Workday from "./Workday";
import WeekMode from "../enums/weekMode";
import WeekModel from "../models/week";
import format from "date-fns/format";
import startOfWeek from 'date-fns/start_of_week';
import lastDayOfWeek from 'date-fns/last_day_of_week';

export default class Week extends Component {
    renderWorkdays = () => {
        let workdays = [];
        let numberOfDaysToShow = this.props.weekMode === WeekMode.WorkWeek ? 5 : 7;

        for (let dayNumber = 1; dayNumber <= numberOfDaysToShow; dayNumber++) {
            let day = this.props.model.days.find(day => day.day === dayNumber);

            if (day === undefined) {
                workdays.push(
                    <Workday
                        key={dayNumber}
                        dummy={true}
                    />);
                continue;
            }

            workdays.push(
                <Workday
                    key={day.day}
                    model={day}
                    selectedEntry={this.props.selectedEntry}
                    onSelectedEntryChanged={this.props.onSelectedEntryChanged}
                />);
        }

        return workdays;
    };

    renderSubtitle = () => {
        if(this.props.model.days === undefined || this.props.model.days.length === 0) {
            return;
        }

        let firstDay = startOfWeek(this.props.model.days[0].date, {weekStartsOn: 1});
        let lastDay = lastDayOfWeek(this.props.model.days[0].date, {weekStartsOn: 1});

        return `${format(firstDay, 'DD.MM.YY')} – ${format(lastDay, 'DD.MM.YY')}`;
    };

    render() {
        return (
            <div className="row">
                <h4 className="col-sm-12">{this.props.model.name}</h4>
                <h5 className="col-sm-12">{this.renderSubtitle()}</h5>
                {this.renderWorkdays()}
            </div>
        )
    }
}

Week.propTypes = {
    model: PropTypes.instanceOf(WeekModel).isRequired,
    weekMode: PropTypes.instanceOf(WeekMode),
    selectedEntry: PropTypes.number,
    onSelectedEntryChanged: PropTypes.func
};

Week.defaultProps = {
    weekMode: WeekMode.WorkWeek
};


// WEBPACK FOOTER //
// ./src/components/Week.js